<template>
  <a-modal
    :visible="visible"
    :width="960"
    :confirm-loading="confirmLoading"
    :footer="null"
    :maskClosable="false"
    @cancel="handleCancel"
    centered
  >
    <template slot="title">
      <span style="font-size: 18px; font-weight: 800">异常数据</span>
      <a-button type="primary" size="small" style="margin-left: 12px; margin-top: -4px; top: -1px">
        {{ exceptionCode }}
      </a-button>
    </template>
    <div v-if="news.id">
      <div style="display: flex">
        <img :src="svg1" alt="" style="width: 34px; height: 34px; margin-top: 6px" />
        <div style="margin-left: 12px; font-size: 14px; font-weight: 500">
          <div>来源：{{ news.source }}</div>
          <dir>爬取时间: {{ news.createTime }} 发布时间: {{ news.publishTime }}</dir>
        </div>
      </div>
      <div style="font-size: 18px; font-weight: 700; margin-top: 31px">
        {{ news.title }}
      </div>
      <div
        style="font-size: 14px; font-weight: 500; color: #595959; margin-top: 24px"
        v-html="news.content"
      ></div>
      <img :src="item" alt="" v-for="(item, index) in news.fileUrlList" :key="index" />

      <div style="text-align: right">
        <a-pagination
          v-model="current"
          :total="total"
          :pageSize="1"
          @change="jiekouopen"
        ></a-pagination>
      </div>
    </div>
    <div v-else style="padding: 50px 0"><a-empty></a-empty></div>
  </a-modal>
</template>

<script>
import { monitorcontent } from '@/api/Monitor/abnormal'
import svg1 from './imgs/ddyz_sel.svg'
export default {
  data() {
    return {
      exceptionCode: '',
      current: 1,
      news: {},
      total: '',
      confirmLoading: false,
      visible: false,
      layout: 'horizontal',
      svg1,
      form: {
        juese: undefined,
        name: undefined,
        people: undefined
      },
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        juese: [{ required: true, message: '请输入角色类型', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      },
      record: {}
    }
  },
  methods: {
    showModel(record) {
      this.record = {}
      this.current = 1
      this.visible = true
      this.record = record
      this.jiekouopen()
      this.exceptionCode = record.exceptionCode
    },
    jiekouopen() {
      let param = {
        pn: this.current,
        pageSize: 1,
        startTime: this.record.preAlertsTime,
        endTime: this.record.nextAlertsTime,
        siteId: this.record.siteId
      }
      monitorcontent(param)
        .then((result) => {
          if (result.code != 200) {
            this.news = {}
          } else {
            this.total = result.extra.page.pageTotal
            if (result.data.length > 0) {
              this.news = result.data[0]
            } else {
              this.news = {}
            }
          }
        })
        .catch((err) => {})
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true

      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>

<style></style>
